// export const backendUrl = 'http://localhost:8000';
export const backendUrl = 'https://www.api.tnb.net';
